/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as marietta from '../../..';

/**
 * 線分スナップを扱うクラス
 */
export default class LineSegmentSnap {
    type: string;

    x1: number;

    y1: number;

    x2: number;

    y2: number;

    radius: number;

    priority: number;

    related: any;

    itemType: string;

    /**
    * コンストラクタ
    */
    constructor(x1: number, y1: number, x2: number, y2: number, radius: number, priority: number, related: any, itemType: string = 'line-segment') {
      this.type = 'line-segment';
      this.x1 = x1;
      this.y1 = y1;
      this.x2 = x2;
      this.y2 = y2;
      this.radius = radius;
      this.priority = priority;
      this.related = related;
      this.itemType = itemType;
    }

    /**
     * 最も近いポイントを取得します
     * @param x
     * @param y
     * @returns
     */
    nearestPoint(x: number, y: number) {
      return {
        ...marietta.webcad.WebCADGlobal.snapManager.closestPointFromLineSegment(this.x1, this.y1, this.x2, this.y2, x, y),
        distance: marietta.webcad.WebCADGlobal.snapManager.distancePointFromLineSegment(this.x1, this.y1, this.x2, this.y2, x, y),
      };
    }

    /**
     * チェックポイントが最も近いポイントです
     * @param x
     * @param y
     * @param distance
     * @returns boolean
     */
    isNear = (x: number, y: number, distance: number) => true
}
